// import { initInputMask } from "@/components/inputMask";
import {
  Form,
  FormField,
  Input,
  Select,
  phoneInputInit,
} from "Components/form";

export function initForms() {
  // initInputMask();
  Input.init();
  Select.init();
  FormField.init();
  Form.init();
  phoneInputInit();
}
